import React, { useEffect, useState } from "react";
import config from "../../../utils/config";
import "font-awesome/css/font-awesome.min.css";
import Container from "react-bootstrap/Container";
import Pagination from "react-js-pagination";

export default function FieldOfficerList() {
  const [fieldOfficerList, setFieldOfficerList] = useState([]);
  const [status, setStatus] = useState("All");
  const [count, setCount] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState("");
  const [searchText, setSearchText] = useState("");

  const getFieldOfficerDetails = () => {
    let url = `${config.API_HOST_URL}/api/FieldOfficer/GetFieldOfficerDetails/rohini.lokare@powerweave.com`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setFieldOfficerList(data);
        setCount(data.length);
      })
      .catch((error) => {
        console.log("Error in request", error);
      });
  };

  useEffect(() => {
    getFieldOfficerDetails();
  }, []);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    // Fetch data for the new page
  };

  const handleSortClick = (field) => {
    setSortBy(field);
    // Add sorting logic here
  };

  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

  const filteredList = fieldOfficerList.filter((officer) => {
    return (
      officer.ProjectName.toLowerCase().includes(searchText.toLowerCase()) ||
      officer.Location.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  return (
    <>
      <div className="headbottom_cont">
        <ul className="headbottom_content">
          <li className="heading_cont">Field Officer List</li>
          <li className="search_container">{/* <Searchcomp /> */}</li>
          <li className="export_btn"></li>
        </ul>
      </div>
      <div className="growalarm_container projectlist_cont">
        <Container>
          <div className="growalarm_content">
            <div className="commontbl_wrap">
              <table className="commontbl_cont">
                <thead>
                  <tr>
                    <th>
                      Project Name
                      <div
                        className="sortArrow"
                        onClick={() => handleSortClick("ProjectName")}
                      >
                        <i
                          className={`fas fa-sort-up ${
                            sortBy === "ProjectName" ? "active" : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-sort-down ${
                            sortBy === "ProjectName" ? "active" : ""
                          }`}
                        ></i>
                      </div>
                    </th>
                    <th>
                      Project Location
                      <div
                        className="sortArrow"
                        onClick={() => handleSortClick("Location")}
                      >
                        <i
                          className={`fas fa-sort-up ${
                            sortBy === "Location" ? "active" : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-sort-down ${
                            sortBy === "Location" ? "active" : ""
                          }`}
                        ></i>
                      </div>
                    </th>
                    <th>
                      Estimated Number of Trees
                      <div
                        className="sortArrow"
                        onClick={() => handleSortClick("NumberOfTrees")}
                      >
                        <i
                          className={`fas fa-sort-up ${
                            sortBy === "NumberOfTrees" ? "active" : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-sort-down ${
                            sortBy === "NumberOfTrees" ? "active" : ""
                          }`}
                        ></i>
                      </div>
                    </th>
                    <th>
                      Land area (in Acre)
                      <div
                        className="sortArrow"
                        onClick={() => handleSortClick("LandArea")}
                      >
                        <i
                          className={`fas fa-sort-up ${
                            sortBy === "LandArea" ? "active" : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-sort-down ${
                            sortBy === "LandArea" ? "active" : ""
                          }`}
                        ></i>
                      </div>
                    </th>
                    <th>
                      Status of Land
                      <div
                        className="sortArrow"
                        onClick={() => handleSortClick("LandStatus")}
                      >
                        <i
                          className={`fas fa-sort-up ${
                            sortBy === "LandStatus" ? "active" : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-sort-down ${
                            sortBy === "LandStatus" ? "active" : ""
                          }`}
                        ></i>
                      </div>
                    </th>
                    <th>
                      Project Type
                      <div
                        className="sortArrow"
                        onClick={() => handleSortClick("ProjectType")}
                      >
                        <i
                          className={`fas fa-sort-up ${
                            sortBy === "ProjectType" ? "active" : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-sort-down ${
                            sortBy === "ProjectType" ? "active" : ""
                          }`}
                        ></i>
                      </div>
                    </th>
                    <th>
                      Status
                      <div
                        className="sortArrow"
                        onClick={() => handleSortClick("Status")}
                      >
                        <i
                          className={`fas fa-sort-up ${
                            sortBy === "Status" ? "active" : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-sort-down ${
                            sortBy === "Status" ? "active" : ""
                          }`}
                        ></i>
                      </div>
                    </th>
                    <th className="action_cont">Action</th>
                  </tr>
                </thead>
                <tbody id="myUL">
                  <tr className="tblsearch_cont">
                    <td colSpan="8">
                      <div className="tblsearch">
                        <i className="fa fa-search"></i>
                        <input
                          autoFocus
                          type="text"
                          id="SearchText"
                          placeholder="Search for Project Name, location…"
                          value={searchText}
                          onChange={handleChange}
                        />
                      </div>
                    </td>
                  </tr>

                  {filteredList.map((officer, index) => (
                    <tr className="tabel-data" key={index}>
                      <td className="projnametd">{officer.ProjectName}</td>
                      <td>{officer.Location}</td>
                      <td className="tdnum">{officer.NumberOfTrees}</td>
                      <td className="tdnum">
                        {(officer.LandArea * 0.000247105).toFixed(2)}
                      </td>
                      <td className="tdnum">{officer.LandStatus}</td>
                      <td className="tdnum">{officer.ProjectType}</td>
                      <td className="tdnum">{officer.Status}</td>
                      {/* <td className="action_cont">
                        {officer.Status === "Unverified" && (
                          <VerifyStatusPopup
                            data={officer}
                            handleBack={() => {}}
                          />
                        )}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="wrapper">
              {count > 0 ? (
                count > pageSize && (
                  <div className="paginationDiv">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={pageSize}
                      totalItemsCount={count}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      nextPageText={<i className="fa fa-angle-right"></i>}
                      prevPageText={<i className="fa fa-angle-left"></i>}
                      lastPageText={
                        <i className="fa fa-angle-double-right"></i>
                      }
                      firstPageText={
                        <i className="fa fa-angle-double-left"></i>
                      }
                    />
                  </div>
                )
              ) : (
                <div>No Results Found</div>
              )}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}
